/**
 * @jsxRuntime classic
 * @jsx jsx
 */


import type { ExternalChapter } from './types';

/**
 * Type guard to filter out null/undefined chapters
 */
export const isChapter: (
	chapter: ExternalChapter | null | undefined,
) => chapter is ExternalChapter = (
	chapter: ExternalChapter | null | undefined,
): chapter is ExternalChapter => chapter !== null && chapter !== undefined;
